import React from "react";
import { useOnMount } from "../../hooks";
import { useRandomId } from "../../hooks/useRandomId";
import styled from "styled-components";
import { useTabContext } from "./context";

const TabSheetDiv = styled.div`
  justify-self: stretch;
`;

const useSheetRegister = (title, tabId, startActive) => {
  const { registerTab, setActiveTabId } = useTabContext();

  useOnMount(() => {
    registerTab(title, tabId);

    if (startActive) {
      setActiveTabId(tabId)
    }
  });
};

const useTabId = (id) => {
  const [tabFallbackId] = useRandomId("tab-");
  return id ?? tabFallbackId;
};

export const TabSheet = ({ title, id, startActive, children }) => {
  const { activeTabId } = useTabContext();
  const tabId = useTabId(id);
  useSheetRegister(title, tabId, startActive);

  if (tabId !== activeTabId) {
    return null;
  }

  return (
    <TabSheetDiv>{children}</TabSheetDiv>
  );
}